/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secureaccessforadministrators3Inputs */

const en_secureaccessforadministrators3 = /** @type {(inputs: Secureaccessforadministrators3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure access for administrators`)
};

const de_secureaccessforadministrators3 = /** @type {(inputs: Secureaccessforadministrators3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherer Zugang für Administratoren`)
};

/**
* | output |
* | --- |
* | "Secure access for administrators" |
*
* @param {Secureaccessforadministrators3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const secureaccessforadministrators3 = /** @type {((inputs?: Secureaccessforadministrators3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secureaccessforadministrators3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_secureaccessforadministrators3(inputs)
	return de_secureaccessforadministrators3(inputs)
});
export { secureaccessforadministrators3 as "secureAccessForAdministrators" }